import { render, staticRenderFns } from "./ProfileDialog.vue?vue&type=template&id=39c71ce9&scoped=true"
import script from "./ProfileDialog.vue?vue&type=script&lang=js"
export * from "./ProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./ProfileDialog.vue?vue&type=style&index=0&id=39c71ce9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c71ce9",
  null
  
)

export default component.exports